module.exports = __webpack_public_path__ + "static/img/tablet-header-icon.f77ea55c.svg";